import AppConstants from '../config/app.constants';

let AtmResidualService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/atm-residual`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let ResidualCountCommit = (fundingSourceId, branchId, pickupDate, pickupTime, branchTimeZone, countedByUserId, children, parentResidual, supervisorId, unfitDenomsData, monthlySupervisorId, monthlyCashCountLimitAmount, totalCountedThisMonth, newCountAmount) => {
        return $http
            .post(AppConstants.api + `/atm-residual/residual-count-commit`, {
                fundingSourceId,
                branchId,
                pickupDate,
                pickupTime,
                branchTimeZone,
                countedByUserId,
                children,
                parentResidual,
                supervisorId,
                unfitDenomsData,
                monthlySupervisorId,
                monthlyCashCountLimitAmount,
                totalCountedThisMonth,
                newCountAmount
            })
            .then((res) => res.data);
    };
    

    let getResidualShipments = (trackingId, toLocationId) => {
        return $http
            .post(AppConstants.api + `/atm-residual/get-residual-shipment`, {
                trackingId,
                toLocationId
            })
            .then((res) => {
                return res.data
            })
    }

    let getResidualBagCount = (fundingSourceId, branchId) => {
        return $http
            .post(AppConstants.api + `/atm-residual/remaining-residual-bag`, {
                fundingSourceId, 
                branchId
            })
            .then((res) => {
                return res.data
            })
    }

    let findAtmResidualRecord = (orderNo, deliveryShipmentId, residualShipmentId) => {
        return $http
            .post(AppConstants.api + `/atm-residual/update-order-type`, {
                orderNo,
                deliveryShipmentId,
                residualShipmentId
            })
            .then((res) => {
                return res.data
            })
    }

    let orderHistory = (branch, startDate, endDate, fundingSource, customerId, searchText, offset, limit, currencyId = null) => {
        return $http
            .post(AppConstants.api + `/atm-residual/get-counted-residuals`, {
                branch,
                startDate, 
                endDate,
                fundingSource,
                customerId,
                searchText,
                offset, 
                limit,
                currencyId
            })
            .then((res) => {
                return res.data
            })
    }

    let ResidualCountEdit = (branchId, countedByUserId, children, parentResidual, branchFundingSourceId, unfitDenomsData, monthlySupervisorId, monthlyCashCountLimitAmount, totalCountedThisMonth, newCountAmount) => {
        return $http
            .post(AppConstants.api + `/atm-residual/residual-count-edit`, {
                branchId,
                countedByUserId,
                children,
                parentResidual,
                branchFundingSourceId,
                unfitDenomsData,
                monthlySupervisorId,
                monthlyCashCountLimitAmount,
                totalCountedThisMonth,
                newCountAmount
            })
            .then((res) => {
                return res.data
            })
    }

    let errorShipmentList = (branchId, fundingSourceId, startDate, endDate, searchText, offset, limit, currencyId = null) => {
        return $http
            .post(AppConstants.api + `/atm-residual/shipment-request-error`, {
                branchId, 
                fundingSourceId,
                startDate, 
                endDate, 
                searchText,
                offset, 
                limit,
                currencyId
            })
            .then((res) => {
                return res.data
            })
    }

    let unpackedShipmentList = (branchId, startDate, endDate, fundingSourceId, customerId, searchText, limit, offset, currencyId = null) => {
        return $http
            .post(AppConstants.api + `/atm-residual/unpacked-shipments`, {
                branchId, 
                startDate, 
                endDate, 
                fundingSourceId, 
                customerId,
                searchText, 
                limit, 
                offset,
                currencyId
            })
            .then((res) => {
                return res.data
            })
    }

    let shipmentInProcess = (branch, startDate, endDate, fundingSource, customerId, searchText, offset, limit, currencyId = null) => {
        return $http
            .post(AppConstants.api + `/atm-residual/shipment-in-process`, {
                branch,
                startDate, 
                endDate,
                fundingSource,
                customerId,
                searchText,
                offset, 
                limit,
                currencyId
            })
            .then((res) => {
                return res.data
            })
    }

    let getVaultDate = (branchId, trackingId) => {
        return $http
            .get(AppConstants.api + `/atm-residual/get-vault-date`, {
                params: {
                    branchId,
                    trackingId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getResidualsCountCommit = (searchText, fundingSourceId, startDate, endDate, denoms, user, offset, limit) => {
        return $http
            .get(AppConstants.api + `/atm-residual/get-residual-count-commit`, {
                params: {
                    searchText,
                    fundingSourceId,
                    startDate, 
                    endDate,
                    denoms, 
                    user
                    // offset,
                    // limit
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getCountedUsers = (branchId, fundingSourceId, startDate, endDate, searchText, offset, limit, status) => {
        return $http
            .get(AppConstants.api + `/atm-residual/get-counted-users`, {
                params: {
                    branchId,
                    fundingSourceId,
                    startDate,
                    endDate,
                    searchText,
                    offset,
                    limit,
                    status
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let authorizeResidualCount = (fundingSourceId, branchId, userId) => {
        return $http
            .post(AppConstants.api + `/atm-residual/authorize-residual-count`, {
                fundingSourceId, 
                branchId,
                userId
            })
            .then((res) => {
                return res.data
            })
    }

    let authorizeDepositsCount = (fundingSourceId, branchId, userId, searchText, startDate, endDate, user, denoms) => {
        return $http
            .post(AppConstants.api + `/atm-residual/authorize-deposits-count`, {
                fundingSourceId,
                branchId,
                userId,
                searchText,
                startDate,
                endDate,
                user,
                denoms
            })
            .then((res) => {
                return res.data
            })
    }

    let getResidualsCompletedApproval = (searchText, fundingSourceId, timezone, startDate, endDate, denoms, user, offset, limit) => {
        return $http
            .get(AppConstants.api + `/atm-residual/get-residuals-completed-approval`, {
                params: {
                    searchText,
                    fundingSourceId,
                    timezone,
                    startDate,
                    endDate,
                    denoms,
                    user,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getDepositsCompletedApproval = (searchText, fundingSourceId, timezone, startDate, endDate, user, denoms, offset, limit) => {
        return $http
            .get(AppConstants.api + `/atm-residual/get-deposits-completed-approval`, {
                params: {
                    searchText,
                    fundingSourceId,
                    timezone,
                    startDate,
                    endDate,
                    user,
                    denoms,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let exportResidualsCompletedApproval = (searchText, fundingSourceId, timezone, startDate, endDate, denoms, user, offset, limit) => {
        return $http
            .get(AppConstants.api + `/atm-residual/export-residuals-completed-approval`, {
                params: {
                    searchText,
                    fundingSourceId,
                    timezone,
                    startDate,
                    endDate,
                    denoms,
                    user,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let exportDepositsResidualsCompletedApproval = (searchText, fundingSourceId, timezone, startDate, endDate, user, denoms, offset, limit) => {
        return $http
            .get(AppConstants.api + `/atm-residual/export-deposits-residuals-completed-approval`, {
                params: {
                    searchText,
                    fundingSourceId,
                    timezone,
                    startDate,
                    endDate,
                    user,
                    denoms,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let exportRemainingResiduals = (route, vaultDate, messengerId, fundingSourceId, branchId, customerIds) => {
        return $http
            .get(AppConstants.api + `/atm-residual/export-remaining-residuals`, {
                params: {
                    route: route,
                    vaultDate: vaultDate,
                    messengerId: messengerId,
                    fundingSourceId: fundingSourceId,
                    branchId: branchId,
                    customerIds: customerIds === null ? null : customerIds.join(',')
                }
            })
            .then((res) => {
                return res.data
            })
    }
    
    let convertToCRV = (branchId, routeId, trackingId, supervisorId) => {
        return $http
            .post(AppConstants.api + `/atm-residual/convert-to-crv`, {
                branchId, 
                routeId, 
                trackingId, 
                supervisorId
            })
            .then((res) => {
                return res.data
            })
    }
    
    let getBagoutContent = (bagSeal) => {
        return $http
            .get(AppConstants.api + `/atm-residual/get-bagout-content`, {
                params: { bagSeal }
            })
            .then((res) => {
                return res.data
            })
    };
    
    let updateShipmentBagseal = (trackingIds, bagId, overrideUserId, fundingSource, userId, routeId) => {
        return $http
            .post(AppConstants.api + `/atm-residual/update-shipment-bagseal`, { trackingIds, bagId, overrideUserId, fundingSource, userId, routeId })
            .then((res) => {
                return res.data
            })
    };

    let getExistingUnfitDenominations = (orderNo, shipmentIds, account) => {
        return $http
            .post(AppConstants.api + `/atm-residual/get-existing-unfit-denominations`, { orderNo, shipmentIds, account })
            .then((res) => {
                return res.data
            })
    };

    let getDepositDenominationBreakdown = (orderNo, trackingId, fromLocationId, countVaultDate) => {
        return $http
            .get(AppConstants.api + `/atm-residual/get-deposit-denomination-breakdown`, { params: { orderNo, trackingId, fromLocationId, countVaultDate } })
            .then((res) => {
                return res.data
            })
    };

    let getExpectedResidual = (branchId, trackingId, shipment, fundingSourceId, orderNo) => {
        return $http
            .get(AppConstants.api + `/atm-residual/get-expected-residual`, { params: { branchId, trackingId, shipment, fundingSourceId, orderNo } })
            .then((res) => {
                return res.data
            })
    };

     let exportOrdersCSV = (tab, branch, startDate, endDate, fundingSource, customerId, searchText, currencyId = null) => {
        return $http
            .post(AppConstants.api + `/atm-residual/export-orders-csv`, {
                tab,
                branch,
                startDate,
                endDate,
                fundingSource,
                customerId,
                searchText,
                currencyId
            })
            .then((res) => {
                return res.data
            })
    };

    return {
        all,
        ResidualCountCommit,
        getResidualShipments,
        getResidualBagCount,
        findAtmResidualRecord,
        orderHistory,
        ResidualCountEdit,
        errorShipmentList,
        unpackedShipmentList,
        shipmentInProcess,
        getVaultDate,
        getResidualsCountCommit,
        getCountedUsers,
        authorizeResidualCount,
        getResidualsCompletedApproval,
        exportResidualsCompletedApproval,
        exportDepositsResidualsCompletedApproval,
        exportRemainingResiduals,
        convertToCRV,
        getBagoutContent,
        updateShipmentBagseal,
        getExistingUnfitDenominations,
        getExpectedResidual,
        authorizeDepositsCount,
        getDepositsCompletedApproval,
        getDepositDenominationBreakdown,
        exportOrdersCSV
    };

};

AtmResidualService.$inject = ['$http', '$q']

export default AtmResidualService;




// WEBPACK FOOTER //
// ./client/app/services/atm-residual.service.js